import { Activity, Bot, CalendarPlus, Check, Clock3, Filter, ListChecks, Settings, ShieldAlert, UserPlus, UserX } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';
import { EmptyState, PageLoading } from '../../components/Shells';
import { api, formatDate } from '../../lib/api';

export function AdminAudit() {
  const [items, setItems] = useState<any[]>([]); const [loading, setLoading] = useState(true); const [filter, setFilter] = useState('all');
  useEffect(() => { api.audit().then(setItems).finally(() => setLoading(false)); }, []);
  const visible = useMemo(() => items.filter((item) => filter === 'all' || actionGroup(item.action) === filter), [items, filter]);
  if (loading) return <PageLoading label="讀取操作紀錄" />;
  return <div className="admin-page page-enter">
    <section className="toolbar-panel audit-filter"><Filter size={17} /><span>顯示：</span>{[['all', '全部'], ['member', '會員'], ['settings', '設定'], ['system', '系統']].map(([value, label]) => <button className={filter === value ? 'active' : ''} onClick={() => setFilter(value)} key={value}>{label}</button>)}</section>
    <section className="admin-panel audit-panel"><div className="panel-heading"><div><p>AUDIT TRAIL</p><h2>操作與系統事件</h2></div><span>最近 {visible.length} 筆</span></div>
      {visible.length ? <div className="audit-list">{visible.map((item) => { const meta = actionMeta(item.action); const Icon = meta.icon; return <article key={item.id}><span className={meta.tone}><Icon size={17} /></span><div><strong>{meta.label}</strong><p>{detailText(item)}</p><small>{item.actor_first_name ? `${item.actor_last_name || ''}${item.actor_first_name}` : '系統自動執行'} · {formatDate(item.created_at, true)}</small></div><code>#{item.id}</code></article>; })}</div> : <EmptyState icon={ListChecks} title="沒有符合的紀錄" body="變更篩選條件查看其他操作。" />}
    </section>
  </div>;
}

function actionGroup(action: string) {
  if (action.startsWith('member') || action.startsWith('membership') || action.includes('member_joined')) return 'member';
  if (action.startsWith('settings') || action.startsWith('plan') || action.startsWith('reply')) return 'settings';
  return 'system';
}

function actionMeta(action: string): { label: string; icon: any; tone: string } {
  const map: Record<string, any> = {
    'bank.created':['匯款訂單已建立',Activity,'blue'], 'bank.reported':['會員已回報匯款',Activity,'blue'],
    'bank.approved':['匯款已入帳並開通會員',Check,'green'], 'bank.needs_info':['請會員補充匯款資料',Clock3,'orange'],
    'bank.reopened':['重新開放匯款回報',Activity,'orange'], 'bank.cancelled':['匯款訂單已取消',Clock3,'gray'],
    'bank.settings':['收款設定已更新',Settings,'gray'], 'bank.notification_retry':['重新傳送會員通知',Bot,'blue'],
    'membership.grant': ['會員資格已更新', CalendarPlus, 'green'], 'telegram.member_joined': ['新會員加入群組', UserPlus, 'blue'],
    'member.kick': ['會員已踢出', UserX, 'orange'], 'member.ban': ['會員已封鎖', ShieldAlert, 'red'], 'member.unban': ['會員已解除封鎖', Check, 'green'],
    'settings.updated': ['群組設定已更新', Settings, 'gray'], 'settings.entry_published': ['置頂入口已發布', Bot, 'blue'],
    'plan.created': ['訂閱方案已建立', CalendarPlus, 'green'], 'plan.updated': ['訂閱方案已更新', Settings, 'gray'],
    'scheduler.grace_kick': ['寬限期到期自動踢出', Clock3, 'orange'], 'notification.created': ['通知已建立', Activity, 'blue']
  };
  const value = map[action] || [action, Activity, action.includes('failed') ? 'red' : 'gray'];
  return { label: value[0], icon: value[1], tone: value[2] };
}

function detailText(item: any) {
  if (item.target_type === 'user') return `會員編號 ${item.target_id}`;
  if (item.target_type === 'order') return `訂單 ${item.target_id}`;
  if (item.target_type === 'group') return `群組 ${item.target_id}`;
  if (item.target_type) return `${item.target_type} #${item.target_id}`;
  return '系統事件';
}
